export default {
  'highlights-heading':
    'Un espacio donde compartir ideas, sugerencias y, por qué no, inspirarte para tus regalos',
}
